import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {createIdSchema} from '../../utils/schemas';

const toolName = 'get-form-submission' as const;

const argumentZod = z.object({
  formSubmissionId: createIdSchema('form submission', true),
  localeId: z
    .string()
    .optional()
    .describe(
      'Optional CMS locale ID. When provided, response field labels are returned in that locale.'
    ),
});

export const getFormSubmissionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get form submission',
  family: 'forms',
  llmTool: {
    name: toolName,
    description:
      'Returns the details of a single form submission including all submitted field values, submission timestamp, IP, host, and the originating form metadata.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteForm', action: 'read'}],
  confirmBeforeExecuting: false,
});

export type GetFormSubmissionArgumentType = z.infer<typeof argumentZod>;
